import React, { type PropsWithChildren } from 'react'

import styles from './drawer.module.scss'

export const DrawerBody: React.FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles['drawer__body']}>{children}</div>
}
